










import Vue from "vue";

// Interfaces
import { Coordinates } from "@/shared/interfaces/Location.interface";

export default Vue.extend({
    components: {
    },
    props: {
        coordinates: {
            type: Object as () => Coordinates,
            required: true
        }
    },
    computed: {
        mapScreenshotUrl: function (): string {
            if (this.coordinates.lat && this.coordinates.lng) {
                const url = `https://api.mapbox.com/styles/v1/mapbox/streets-v9/static/pin-s+133DBD(${this.coordinates.lng},${this.coordinates.lat})/${this.coordinates.lng},${this.coordinates.lat},14/560x308/?access_token=${process.env.VUE_APP_IMMOWEB_MAPBOX_API_TOKEN}&logo=false`;
                return url;
            }

            return "";
        }
    },
});
